export const LOCAL_STORAGE = {
  JWT: "bf-public-jwt"
};
